import React, { useEffect, useState } from 'react';
import { useAppContext } from '../AppContext';

interface SplashScreenProps {
    onFinish: () => void;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ onFinish }) => {
    const { appConfig } = useAppContext();
    const [animationStep, setAnimationStep] = useState(0);

    useEffect(() => {
        // Step 1: Fade in/Slide up
        const t1 = setTimeout(() => setAnimationStep(1), 300);
        // Step 2: Show text
        const t2 = setTimeout(() => setAnimationStep(2), 1000);
        // Step 3: Finish
        const t3 = setTimeout(() => onFinish(), 2500);

        return () => {
            clearTimeout(t1);
            clearTimeout(t2);
            clearTimeout(t3);
        };
    }, [onFinish]);

    return (
        <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center splash-bg-cosmic text-white overflow-hidden bg-[#1a0537]">
            <div className={`transition-all duration-1000 transform ${animationStep >= 1 ? 'scale-100 opacity-100' : 'scale-50 opacity-0'}`}>
                {appConfig.logoUrl && (
                    <img 
                        src={appConfig.logoUrl} 
                        alt="Logo" 
                        className="w-40 h-40 object-contain drop-shadow-[0_0_25px_rgba(168,85,247,0.6)] animate-spin-reveal" 
                    />
                )}
            </div>
            
            <div className={`mt-8 text-center transition-all duration-1000 ${animationStep >= 2 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                <h1 className="text-5xl font-extrabold tracking-tighter" style={{ fontFamily: "'Caveat', cursive" }}>
                    <span className="aurora-text">What Was It?</span>
                </h1>
                <p className="text-lg text-gray-300 mt-2 font-light tracking-widest uppercase">
                    <span className="comet" style={{ '--tx-start': '-50px', '--ty-start': '20px' } as any}>Guess.</span>
                    <span className="mx-2 opacity-50">·</span>
                    <span className="comet" style={{ animationDelay: '0.2s', '--tx-start': '0px', '--ty-start': '30px' } as any}>Create.</span>
                    <span className="mx-2 opacity-50">·</span>
                    <span className="comet" style={{ animationDelay: '0.4s', '--tx-start': '50px', '--ty-start': '20px' } as any}>Solve.</span>
                </p>
            </div>

            <div className="absolute bottom-10">
                <div className="spinner-white h-8 w-8 border-4 border-white/20 border-l-purple-500"></div>
            </div>
        </div>
    );
};

export default SplashScreen;